// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WCRF","name":"styles_name__3eqDD","phone":"styles_phone__2EpgB"};